import {Image} from '@shopify/hydrogen';
import {CardStyle, getRichLinkCardStyle} from 'shared/utils/CardStyleUtil';
import classNames from 'classnames';
import React from 'react';

interface ProductLinkCardProps extends React.DOMAttributes<HTMLDivElement> {
  title: string;
  image?: string;
  imageCaption?: string;
  description?: string;
  price?: React.ReactNode;
  style: CardStyle;
}

export const ProductLinkCard = (props: ProductLinkCardProps) => {
  const {title, image, imageCaption, description, price, style, ...divProps} =
    props;

  return (
    <div
      {...divProps}
      className={classNames(
        'flex',
        'w-full',
        'text-black',
        'rounded',
        'bg-white',
        'shadow',
        'px-1',
        'py-4',
        'sm:py-1',
        'gap-4',
        'flex-col',
        {'sm:flex-row': image},
      )}
      style={getRichLinkCardStyle(style)}
      role="button"
    >
      {image && (
        <div className={classNames('relative', 'sm:w-1/3')}>
          <Image
            className={classNames('mx-auto', 'max-h-52', 'object-contain')}
            width={344}
            height={180}
            src={image}
            alt={title}
          />
          {imageCaption && (
            <p
              className={classNames(
                'absolute',
                'bottom-0',
                'text-xs',
                'px-2',
                'py-1',
                'bg-gray-200',
                'rounded-tr-md',
              )}
            >
              {imageCaption}
            </p>
          )}
        </div>
      )}
      <div
        className={classNames(
          'flex-1',
          'flex',
          'flex-col',
          'justify-center',
          'text-sm',
          'text-center',
          {
            'sm:text-left': Boolean(image),
          },
        )}
      >
        <p className={classNames('font-bold', 'text-lg', 'mb-3')}>{title}</p>

        {!!description && (
          <p
            className={classNames(
              'mb-3',
              'hidden',
              'sm:line-clamp-3',
              '[word-break:normal]',
              '[overflow-wrap:anywhere]',
            )}
          >
            {description}
          </p>
        )}

        {price}
      </div>
    </div>
  );
};
